import React from 'react';
import { Link } from 'react-router-dom';

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

export interface BreadcrumbPart {
    label: string;
    path?: string;
}

export interface BreadcrumbsProps {
    parts: BreadcrumbPart[];
}

export const Breadcrumbs = ({ parts }: BreadcrumbsProps) => {
    if (!parts.length) return null;

    return (
        <Breadcrumb>
            <BreadcrumbList>
                {parts.map((part, index) => {
                    const isLast = index === parts.length - 1;

                    return (
                        <React.Fragment key={index}>
                            <BreadcrumbItem>
                                {isLast ? (
                                    <BreadcrumbPage>{part.label}</BreadcrumbPage>
                                ) : !part.path ? (
                                    <span>{part.label}</span>
                                ) : (
                                    <BreadcrumbLink asChild>
                                        <Link to={part.path}>{part.label}</Link>
                                    </BreadcrumbLink>
                                )}
                            </BreadcrumbItem>
                            {!isLast && <BreadcrumbSeparator />}
                        </React.Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
};
